import { UPDATE_SURGE_COMPAIGN, UPDATE_SURGE_COMPAIGN_SUCCESS, UPDATE_SURGE_COMPAIGN_ERROR, UPDATE_SURGE_COMPAIGN_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateSurgeCompaign = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SURGE_COMPAIGN:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_SURGE_COMPAIGN_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPDATE_SURGE_COMPAIGN_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPDATE_SURGE_COMPAIGN_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateSurgeCompaign;
